module.exports = ".mt-20{margin-top:20px}.w-130{width:130px}.w-237{width:237px}\n"